import React from 'react';

import Badge, {BadgeColor} from 'ui-library/Badge';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import {callOnEnterOrSpace} from 'util/Keyboard';
import {ElementKeyboardEvent, ElementMouseEvent} from 'util/Types';

export interface BufferNavItemProps {
  closeable: boolean;
  inBeta: boolean;
  onClose: (e: ElementMouseEvent | ElementKeyboardEvent) => void;
  title: string | null;
}

export default function BufferNavItem({closeable, inBeta, onClose, title}: BufferNavItemProps): JSX.Element {
  return (
    <>
      <div className="sectionTabs-navItem-title">
        <span className="sectionTabs-navItem-title-inner">{title || '-'}</span>
      </div>
      {inBeta && (
        <span className="sectionTabs-navItem-title u-tiny-spacing-left">
          <Badge color={BadgeColor.GREEN}>beta</Badge>
        </span>
      )}
      {closeable && (
        <div className="sectionTabs-navItem-closeBtn">
          <BenchlingIcon
            altText="Close"
            icon="close"
            className="sectionTabs-navItem-closeBtn-svg"
            onClick={onClose}
            onKeyDown={callOnEnterOrSpace((e) => {
              onClose(e!);
            })}
            role="button"
            tabIndex={0}
          />
        </div>
      )}
    </>
  );
}
